import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import es from './locales/es'
import { storageUtils } from './utils/storage'

export const i18n = createI18n({
  legacy: false,
  locale: storageUtils.getLanguage(),
  fallbackLocale: 'zh',
  messages: { zh, en, es }
})
